import { Center, chakra, Flex } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { useMedia } from "@/hooks/useMedia";
import SignCanvas from "./SignCanvas";
import { useHooks } from "./hooks";
import Agreement from "./Agreement";
import { BXButton } from "@/styles";
import BXLoading from "@/components/ui/pay-loading";

const Wrap = chakra(Flex, {
  baseStyle: {
    w: "100%",
    height: "auto",
    flexDirection: "column",
    justifyContent: "center",
  },
});

const AgreementSign = ({ setStep, status }) => {
  const { t } = useI18n();
  const { isMobile } = useMedia();

  const {
    stage,
    setStage,
    layer,
    setLayer,
    agreementDisabled,
    setAgreementDisabled,
    checkedAgreement,
    setCheckedAgreement,
    checkedSign,
    setCheckedSign,
    canSubmit,
    handleSubmit,
    uploadLoading,
    setIsDrew,
    signImgUrl,
    setSignImgUrl,
  } = useHooks({ setStep });

  const hanldeNext = () => {
    handleSubmit();
  };

  return (
    <>
      <Wrap w={isMobile ? "calc(100% - 10px)" : "930px"} mt={"30px"}>
        <>
          <Center fontSize={24} fontWeight={700} mb={"20px"}>
            {t("VolIoTOyfztDOMkegw")}
          </Center>
          <Agreement
            agreementDisabled={agreementDisabled}
            setAgreementDisabled={setAgreementDisabled}
            checkedAgreement={checkedAgreement}
            setCheckedAgreement={setCheckedAgreement}
          />

          <SignCanvas
            stage={stage}
            setStage={setStage}
            layer={layer}
            setLayer={setLayer}
            checkedSign={checkedSign}
            setCheckedSign={setCheckedSign}
            setIsDrew={setIsDrew}
            signImgUrl={signImgUrl}
            setSignImgUrl={setSignImgUrl}
          />

          <Flex justifyContent={"center"} mt="30px" mb={"50px"}>
            <BXButton mr="10px" onClick={() => setStep(2)} className="cancel">
              {t("WbPTckCFMKtPHgAlL")}
            </BXButton>
            <BXButton
              className={!canSubmit ? "disabled" : ""}
              fontSize="14px"
              padding="0 30px"
              w={["100%", "200px"]}
              onClick={() => {
                if (canSubmit) {
                  hanldeNext();
                }
              }}
            >
              {t("tOaRBVUJHpnSgDBrGON")}
            </BXButton>
          </Flex>
        </>
      </Wrap>

      {uploadLoading && <BXLoading />}
    </>
  );
};

export default AgreementSign;
